/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A1Inputs */

const en_to_typescript_faq_a1 = /** @type {(inputs: To_Typescript_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They accurately describe the sample you pasted. Whether that matches the API contract depends on how representative your sample is. Paste an array of several records with optional fields both present and absent for the best result.`)
};

const ko_to_typescript_faq_a1 = /** @type {(inputs: To_Typescript_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`붙여넣은 샘플을 정확히 서술합니다. 그것이 API 계약과 일치하는지는 샘플이 얼마나 대표성이 있는지에 달려 있습니다. 선택적 필드가 있는 경우와 없는 경우가 모두 들어간 레코드 여러 개의 배열을 붙여넣는 것이 가장 좋습니다.`)
};

const ja_to_typescript_faq_a1 = /** @type {(inputs: To_Typescript_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたサンプルを正確に記述します。それが API の契約と一致するかは、サンプルにどれだけ代表性があるかによります。任意フィールドが存在する場合と欠ける場合の両方が入ったレコード数件の配列を貼り付けるのが最良です。`)
};

/**
* | output |
* | --- |
* | "They accurately describe the sample you pasted. Whether that matches the API contract depends on how representative your sample is. Paste an array of several..." |
*
* @param {To_Typescript_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a1 = /** @type {((inputs?: To_Typescript_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a1(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a1(inputs)
	return ja_to_typescript_faq_a1(inputs)
});